/*
 * @function: 跳转ui
*/
import { trackEvent } from '../../trackEvent/index'
const waitView = {}
let timer = null
let link = null

function creatWaitView () {
  if (waitView.rootView) {
    return waitView
  }
  // 创建dom节点
  waitView.rootView = document.createElement('div')
  waitView.container = document.createElement('div')
  waitView.titleText = document.createElement('div')
  waitView.descText = document.createElement('div')
  waitView.waitTextView = document.createElement('div')
  waitView.waitText = document.createElement('span')
  waitView.timerText = document.createElement('span')
  waitView.buttonGroup = document.createElement('div')
  waitView.cancelBtn = document.createElement('div')
  waitView.linkBtn = document.createElement('div')

  // 设置每个节点样式和内容
  waitView.titleText.innerText = '温馨提示'
  waitView.waitText.innerText = '请稍后'

  // title 第一行文字 温馨提示
  waitView.titleText.style.color = '#353535'
  waitView.titleText.style.fontSize = '4.8vw'
  waitView.titleText.style.fontWeight = 'bold'

  // sub title 第二行文字 拉端描述信息
  waitView.descText.style.color = '#353535'
  waitView.descText.style.fontSize = '3.46vw'
  waitView.descText.style.fontWeight = '500'

  // 第三行文字 左边文字 请稍后
  waitView.waitText.style.color = '#FF7D41'
  waitView.waitText.style.fontSize = '3.73vw'
  waitView.waitText.style.fontWeight = 'bold'

  // 第三行文字 右边文字 (5s)
  waitView.timerText.style.color = '#505050'
  waitView.timerText.style.fontSize = '3.73vw'

  // 第三行文字父级元素对应dom
  waitView.waitTextView.style.display = 'flex'
  waitView.waitTextView.style.flexDirection = 'row'
  waitView.waitTextView.style.justifyContent = 'center'
  waitView.waitTextView.style.width = '100%'

  // 第四行按钮父级元素对应dom
  waitView.buttonGroup.style.display = 'flex'
  waitView.buttonGroup.style.flexDirection = 'row'
  waitView.buttonGroup.style.justifyContent = 'space-around'
  waitView.buttonGroup.style.width = '100%'

  // 整个拉端蒙层对应的dom
  waitView.rootView.className = 'launch-app-wait-view'
  waitView.rootView.style.position = 'fixed'
  waitView.rootView.style.width = '100vw'
  waitView.rootView.style.height = '100vh'
  waitView.rootView.style.backgroundColor = 'rgba(0, 0, 0, .6)'
  waitView.rootView.style.zIndex = '9999'
  waitView.rootView.style.top = '0'
  waitView.rootView.style.left = '0'

  // 拉端半弹窗对应的dom
  waitView.container.style.boxSizing = 'border-box'
  waitView.container.style.position = 'fixed'
  waitView.container.style.zIndex = '9999'
  waitView.container.style.bottom = '0'
  waitView.container.style.left = '0'
  waitView.container.style.right = '0'
  waitView.container.style.margin = '0 auto'
  waitView.container.style.padding = '0 7.7vw'
  waitView.container.style.width = '96vw'
  waitView.container.style.height = '35.7vw'
  waitView.container.style.textAlign = 'center'
  waitView.container.style.backgroundColor = '#FFFFFF'
  waitView.container.style.display = 'flex'
  waitView.container.style.flexDirection = 'column'
  waitView.container.style.alignItems = 'center'
  waitView.container.style.justifyContent = 'space-around'
  waitView.container.style.borderRadius = '6vw 6vw 0 0'

  // 底部按钮
  waitView.cancelBtn.innerText = '关闭'
  waitView.cancelBtn.style.color = '#353535'
  waitView.cancelBtn.style.fontSize = '3.73vw'
  waitView.cancelBtn.style.fontWeight = 'bold'
  waitView.cancelBtn.style.padding = '2px 20px'
  waitView.cancelBtn.style.border = '1px solid rgba(0, 0, 0, 0.2)'
  waitView.cancelBtn.style.borderRadius = '16px'
  waitView.cancelBtn.onclick = function () {
    timer && clearInterval(timer)
    waitView.callbackMap.closeCallback && waitView.callbackMap.closeCallback(link)
    // 埋点：点击暂不点击
    trackEvent('userteam_ad_zj_countdown_no_ck')
  }
  waitView.linkBtn.innerText = '打开'
  waitView.linkBtn.style.color = '#FF7D41'
  waitView.linkBtn.style.fontSize = '3.73vw'
  waitView.linkBtn.style.fontWeight = 'bold'
  waitView.linkBtn.style.padding = '2px 20px'
  waitView.linkBtn.style.border = '1px solid rgb(255, 125, 65, 0.6)'
  waitView.linkBtn.style.borderRadius = '16px'
  waitView.linkBtn.onclick = function () {
    waitView.callbackMap.clickCallback && waitView.callbackMap.clickCallback(link)
    // 埋点：点击打开
    trackEvent('userteam_ad_zj_countdown_open_ck', { URL: link })
  }

  // 由子到父层级关系依次挂载节点
  waitView.waitTextView.appendChild(waitView.waitText)
  waitView.waitTextView.appendChild(waitView.timerText)

  waitView.buttonGroup.appendChild(waitView.cancelBtn)
  waitView.buttonGroup.appendChild(waitView.linkBtn)

  waitView.container.appendChild(waitView.titleText)
  waitView.container.appendChild(waitView.descText)
  waitView.container.appendChild(waitView.waitTextView)
  waitView.container.appendChild(waitView.buttonGroup)

  waitView.rootView.appendChild(waitView.container)

  return waitView
}

export function updateDescText (text) {
  if (!waitView.descText) return
  waitView.descText.innerText = text
}

export function updateTimerText (timeout, link) {
  if (!waitView.timerText) return
  let waitTime = timeout / 1000

  timer && clearInterval(timer)

  timer = setInterval(async () => {
    waitView.timerText.innerText = `（${waitTime}s）`
    if (waitTime <= 0) {
      clearInterval(timer)
      waitView.callbackMap.timeoutCallback && waitView.callbackMap.timeoutCallback(link)
    }
    waitTime--
  }, 1000)
}

export function updateLink (url) {
  link = url
}

export function removeView () {
  waitView.rootView.parentElement.removeChild(waitView.rootView)
  waitView.rootView = null
}

export function openWaitView (callbackMap) {
  const waitView = creatWaitView()
  waitView.callbackMap = callbackMap
  document.body.appendChild(waitView.rootView)
}
